


























import { Component, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import { OnboardingURL } from '@/views/Onboarding/helpers';
import GooglePreviewBusiness from '@/componentsV2/organisms/GooglePreviewBusinessV2/GooglePreviewBusinessV2.vue';
import { Picture } from '@/components/atoms';
import BusinessOnboardingModel from '@/views/BusinessOnboarding/BusinessOnboardingModel.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    FilledButton,
    Typography,
    GooglePreviewBusiness,
    Picture
  }
})
export default class BusinessPreview extends BusinessOnboardingModel {
  data = {
    ...this.yourStoreDetailsFormData,
    ...this.yourStoreFormData,
    category: this.businessCategoryForm.selectedCategory
  };

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get businessCategoryForm() {
    return (
      this.$store.getters['businessOnboarding/getYourBusinessCategoryForm'] ||
      {}
    );
  }

  get yourStoreFormData() {
    return this.$store.getters['businessOnboarding/getYourStoreForm'];
  }

  get yourStoreDetailsFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'];
  }

  get businessOnboardingState() {
    return this.$store.getters['businessOnboarding/getBusinessOnboardingState'];
  }

  editBusiness() {
    this.$router.push(OnboardingURL.AI_BUSINESS_EDIT);
  }

  goBack() {
    document.location.href = process.env.VUE_APP_URL || 'https://www.twism.com';
  }

  saveBusinessLeadAndTrack() {
    this.saveBusinessLead();
    segmentIo.track(`AI Sign Up | Saved Business Lead`);
  }

  async onSubmit() {
    this.saveBusinessLeadAndTrack();
    this.$router.push(OnboardingURL.AI_LOADING);
  }

  created() {
    this.saveBusinessLeadAndTrack();
  }
}
